import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import demo_map from "./demo_map.png";

function MapView({ selectedFiles }) {
  const [paths, setPaths] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const cacheRef = useRef({});

  useEffect(() => {
    let isCancelled = false;

    async function fetchSelectedFiles() {
      const total = selectedFiles.length;
      const cachedCount = selectedFiles.filter(
        (fileId) => cacheRef.current[fileId]
      ).length;
      if (total > 0) {
        setProgress(Math.round((cachedCount / total) * 100));
      } else {
        setProgress(100);
      }
      const filesToLoad = selectedFiles.filter(
        (fileId) => !cacheRef.current[fileId]
      );
      if (filesToLoad.length > 0) {
        setLoading(true);
        let loaded = 0;
        for (let fileId of filesToLoad) {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_API_URL}/files/${encodeURIComponent(
                fileId
              )}/data`
            );
            cacheRef.current[fileId] = res.data;
          } catch (err) {
            console.error(err);
          }
          loaded++;
          if (!isCancelled) {
            setProgress(Math.round(((cachedCount + loaded) / total) * 100));
          }
        }
        if (!isCancelled) {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
      if (!isCancelled) {
        setPaths(
          selectedFiles.map((fileId) => ({
            fileId,
            data: cacheRef.current[fileId],
          }))
        );
      }
    }

    fetchSelectedFiles();
    return () => {
      isCancelled = true;
    };
  }, [selectedFiles]);

  const mapWidth = 1000;
  const mapHeight = 1000;
  const colors = ["red"];

  if (loading) {
    return (
      <div
        style={{
          position: "relative",
          width: mapWidth,
          height: mapHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="spinner">Loading... {progress}%</div>
      </div>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      <img
        src={demo_map}
        alt="Game Map"
        style={{ width: mapWidth, height: mapHeight }}
      />
      <svg
        width={mapWidth}
        height={mapHeight}
        style={{ position: "absolute", top: 0, left: 0 }}
      >
        {paths.map((pathObj, idx) =>
          pathObj.data.map((p, pointIdx) => {
            const x = parseFloat(p.x) || 0;
            const y = parseFloat(p.y) || 0;
            const color = colors[idx % colors.length];
            return (
              <circle
                key={`${pathObj.fileId}-${pointIdx}`}
                cx={x}
                cy={y}
                r={3}
                fill={color}
                opacity={0.18}
              />
            );
          })
        )}
      </svg>
    </div>
  );
}

export default MapView;
